import { ChangeEvent, DataSourceMode, LookupModelSearchEvent, Textbox } from "@mcleod/components";
import { LocationByTypeProps, LocationByTypeUtil } from "../LocationByTypeUtil";
import { AutogenLayoutCarrierTargetLaneRate } from "./autogen/AutogenLayoutCarrierTargetLaneRate";
import { RateUtil } from "../RateUtil";
import { CustomerFscQuickInfo } from "@mcleod/ar";

const LOCATION_BY_TYPE_PROPS: LocationByTypeProps = {
    cityType: "C",
    stateType: "S",
    zoneType: "O",
    locationType: "L",
    countyType: "N",
    useDefault: true,
    lookupProps: {
        freeform: {
            lookupModelAllowFreeform: true
        }
    }
}

const POINT_TO_POINT_ALLOWED = ['C', 'L'];

const FUEL_SURCHARD_REQUIRED = ['B', 'I', 'M'];

export class CarrierTargetLaneRate extends AutogenLayoutCarrierTargetLaneRate {

    onLoad(): void | Promise<void> {
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxOriginCode, this.textboxOrigin, LOCATION_BY_TYPE_PROPS);
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxDestinationCode, this.textboxDestination, LOCATION_BY_TYPE_PROPS);
        RateUtil.setupCountyHandler(this.textboxOriginCode, this.textboxOrigin, [this.textboxOriginCounties, this.textboxOriginState], LOCATION_BY_TYPE_PROPS.countyType);
        RateUtil.setupCountyHandler(this.textboxDestinationCode, this.textboxDestination, [this.textboxDestinationCounties, this.textboxDestinationState], LOCATION_BY_TYPE_PROPS.countyType);
        this.textboxFuelSurchargePay.quickInfoOverrideSearchMethod = CustomerFscQuickInfo.fuelSurchargePaySearchMethod;
    }

    syncPtToPt() {
        if (this.mainDataSource.mode != DataSourceMode.SEARCH) {
            const originType = this.activeRow.getString('origin_type', null);
            const destinationType = this.activeRow.getString('destination_type', null);
            const validOrigin = POINT_TO_POINT_ALLOWED.includes(originType)
                                && !this.textboxOrigin.isEmpty()
                                && ('L' != originType || this.textboxOrigin.lookupModelData?.length == 1);

            const validDest = POINT_TO_POINT_ALLOWED.includes(destinationType)
                                && !this.textboxDestination.isEmpty()
                                && ('L' != destinationType || this.textboxDestination.lookupModelData?.length == 1);
            this.switchPtToPt.enabled = validOrigin && validDest;
            if (!this.switchPtToPt.enabled) {
                this.switchPtToPt.checked = false;
            }
            this.switchPtToPt.disabledTooltip = "Point-to-Point is only allowed for Origin/Destination values of type City/State and single values of type Location";
        }
    }

    textboxFuelSurchargePayBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.surcharge_type = 'R';
    }

    textboxMaxPayMethodOnChange(event: ChangeEvent) {
        const maxPayMethod = (event.target as Textbox)?.selectedItem?.value;
        this.shouldRequireFuelSurcharge(this.textboxTargetPayMethod?.selectedItem?.value, maxPayMethod);
        this.syncWithRateMethod(maxPayMethod, this.textboxMaxPayRate, true)
    }

    
    textboxTargetPayMethodOnChange(event: ChangeEvent) {
        const targetPayMethod = (event.target as Textbox)?.selectedItem?.value;
        this.shouldRequireFuelSurcharge(targetPayMethod, this.textboxMaxPayMethod?.selectedItem?.value);
        this.syncWithRateMethod(targetPayMethod, this.textboxTargetPayRate, false)
    }

    shouldRequireFuelSurcharge(targetPayMethod: string, maxPayMethod: string) {
        this.textboxFuelSurchargePay.required = 
            FUEL_SURCHARD_REQUIRED.includes(targetPayMethod) || FUEL_SURCHARD_REQUIRED.includes(maxPayMethod)
    }
    
    syncWithRateMethod(rateMethod: string, rateTextbox: Textbox, maxRate: boolean) {
        rateTextbox.required = rateTextbox.visible = ('N' !== rateMethod);
        switch(rateMethod) {
            case 'F': 
                rateTextbox.caption = 'Flat Rate';
                rateTextbox.tooltip = 'Flat Rate';
                break;
            case 'D': 
                rateTextbox.caption = 'Per Unit Rate';
                rateTextbox.tooltip = 'Per Distance Unit Rate';
                break;
            case 'P': 
                rateTextbox.caption = maxRate ? 'Percent of Total Charge' : 'Total Charge Margin';
                rateTextbox.tooltip = 'Percentage of total charge (for a 20% margin on total charges, enter 20).';
                break;
            case 'N':  
                rateTextbox.caption = null;
                rateTextbox.tooltip = null;
                break;
            default: 
                rateTextbox.caption = 'Percent of Market Rate';
                rateTextbox.tooltip = 'Percentage of the selected market rate (for a 90% market rate, enter 90).';
                break;
        }
    }
}
